export enum CardType {
  visaCredit = 'Visa Credit',
  visaDebit = 'Visa Debit',
  mastercardCredit = 'Mastercard Credit',
  mastercardDebit = 'Mastercard Debit',
  discoverCredit = 'Discover Credit',
  discoverDebit = 'Discover Debit',
  americanExpress = 'American Express',
}
